import { tealiumEventPageTypes, PageNames, SegmentSources } from '@foxcorp/delta-web-analytics';
import { getShowType } from 'helpers/ContentHelper';
import { getFavorites as fetchFavoriteDetails } from 'helpers/Account';
import {
  getFavoriteRequestOptions,
  FAVORITE_DOMAINS,
  filterByFavoriteType,
} from 'helpers/AccountHelper';
import { helperGetApiSeriesUrlRoute, helperGetFavoriteDetailsApiRoute } from 'helpers/ApiHelper';

export const getFavoriteData = ({ item }) => {
  const id = item?.id;
  const type = item?.['@type'];
  const favoriteData = {
    actionLocation: 'playlist',
    favoritableItems: [{ '@type': type, id }],
    favoriteType: 'personality',
    location: tealiumEventPageTypes?.[PageNames.HOME],
    networkId: item?.network,
    recommendationId: item?.trackingData?.properties.recommendationId ?? '',
    seriesName: item?.name,
    showID: item?.showCode,
    showType: getShowType({ videoType: item?.videoType, seriesType: item?.seriesType }),
    source: SegmentSources.DETAIL,
  };
  return favoriteData;
};

export const fetchNextPage = async ({ account, nextUrl, setWatchlistItems, setNextUrl }) => {
  if (!nextUrl) return null;
  const showCode = nextUrl?.split('showCode=')[1];
  const nextFavoritesRoute = helperGetApiSeriesUrlRoute({ showCode });
  const options = { ...getFavoriteRequestOptions({ account }), route: nextFavoritesRoute };
  fetchFavoriteDetails(options).then(result => {
    const newItems = result?.member ?? [];
    const newNextUrl = result?.view?.next;
    setWatchlistItems(prevItems => [...prevItems, ...newItems]);
    setNextUrl(newNextUrl);
  });
  return null;
};

export const fetchFavorites = async ({
  account,
  profileFavorites,
  setIsLoading,
  setIsWatchlistEmpty,
  setNextUrl,
  setWatchlistItems,
}) => {
  setIsLoading(true);
  const { favorites } = await profileFavorites.get({ domains: FAVORITE_DOMAINS });
  const filteredFavorites = filterByFavoriteType(favorites);
  const favoritesShowIds = filteredFavorites.map(item => item.id);
  const route = helperGetFavoriteDetailsApiRoute(favoritesShowIds);
  const options = { ...getFavoriteRequestOptions({ account }), route };
  const favoritesDetails = await fetchFavoriteDetails(options);
  const favoriteItems = favoritesDetails?.member;
  if (filteredFavorites.length <= 0 || favoriteItems.length <= 0) {
    setIsWatchlistEmpty(true);
    setIsLoading(false);
    return null;
  }
  const nextUrl = favoritesDetails?.view?.next;
  if (nextUrl) setNextUrl(nextUrl);
  setWatchlistItems(() => [...favoriteItems]);
  setIsLoading(false);
  return null;
};
